import React from "react";

const BankingInfoForm = ({ formData, setFormData, handleNext, handleBack }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    console.log(formData);
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // prevent page reload
    console.log("Submitted data:", formData);
    sessionStorage.setItem("form", JSON.stringify(formData));
    handleNext();
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-full mx-auto p-6">
      <div className="bg-white rounded-lg p-6">
        {/* Bank name */}
        <div className="mb-4">
          <label className="block font-medium text-gray-800 mb-1">
            Bank name
          </label>
          <input
            type="text"
            placeholder="Enter bank name"
            name="bank_name"
            value={formData?.bank_name || ""}
            onChange={handleChange}
            className="mt-1 w-full p-2 border rounded"
          />
        </div>

        {/* Account name and number */}
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <div className="flex-1">
            <label className="block font-medium text-gray-800 mb-1">
              Account name
            </label>
            <input
              required
              type="text"
              placeholder="Enter account name"
              name="account_name"
              value={formData?.account_name || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
            />
          </div>
          <div className="flex-1">
            <label className="block font-medium text-gray-800 mb-1">
              Account number
            </label>
            <input
              required
              type="number"
              placeholder="Enter account number"
              name="account_number"
              value={formData?.account_number || ""}
              onChange={handleChange}
              className="mt-1 w-full p-2 border rounded"
            />
          </div>
        </div>

        {/* Business transaction volume */}
        <div className="mb-6">
          <label className="block font-medium text-gray-800 mb-1">
            Business transaction volume
          </label>
          <input
            type="text"
            placeholder="Enter business transaction volume"
            name="business_transaction_value"
            value={formData?.business_transaction_value || ""}
            onChange={handleChange}
            className="mt-1 w-full p-2 border rounded"
          />
        </div>
      </div>
      <div className="flex justify-center mt-6">
        <button
          type="button"
          onClick={handleBack}
          className="px-6 py-2 bg-gray-300 rounded"
        >
          Back
        </button>{" "}
        <button
          type="submit"
          className="ml-auto px-6 py-2 bg-blue-600 text-white rounded"
        >
          Next
        </button>
      </div>
    </form>
  );
};

export default BankingInfoForm;
